import './CombateTirano.css';
import React, { useEffect, useState } from 'react'; // Importar useState
import { useLocation } from 'react-router-dom';
import { useStateContext } from './StateContext'; // Importa el hook del contexto
import { useNavigate } from 'react-router-dom';

const CombateTirano = () => {
    const location = useLocation(); // Hook para obtener el estado de la navegación
    const navigate = useNavigate();

    const { updatedDeckInfoJSON, verCartaTirano } = location.state || {}; // Obtén la cadena JSON del estado

    const deckInfo = updatedDeckInfoJSON ? JSON.parse(updatedDeckInfoJSON) : {}; // Parsear JSON si es una cadena

    // Verifica que deckInfo no sea undefined
    //console.log('combate Tirano deckInfo:', updatedDeckInfoJSON);

    const { updateNumDays, updateLimDays, updateBqValue, updateProgress, updateLimProgress, updateHeaderFieldDaysColor } = useStateContext(); // Usa el contexto para actualizar el estado

    const { selectedVillain, numPlayers, cardList, progresoActual, diasActual, cartaDelMazo, revisarEncuentros, objetoNoSubirDia, objetoEncuentro34Dia } = deckInfo;

    const [initialized, setInitialized] = useState(false); // Estado para controlar la inicialización

    // Estado para controlar si se muestra la imagen frontal o la trasera
    const [showBackImage, setShowBackImage] = useState(false);
    const [imageNumber, setImageNumber] = useState(0); // Estado para controlar el número de la imagen actual

    const [showQuestionBox, setShowQuestionBox] = useState(false);
    const [questionText, setQuestionText] = useState("");
    const [button1Text, setButton1Text] = useState("");
    const [button2Text, setButton2Text] = useState("");
    const [button1Action, setButton1Action] = useState(() => {});
    const [button2Action, setButton2Action] = useState(() => {});

    // Función para mostrar la pregunta con texto y funciones dinámicas
    const showQuestion = (question, btn1Text, btn2Text, btn1Action, btn2Action) => {
        setQuestionText(question);
        setButton1Text(btn1Text);
        setButton2Text(btn2Text);
        setButton1Action(() => btn1Action);
        setButton2Action(() => btn2Action);
        setShowQuestionBox(true);
    };

    useEffect(() => {
        if (deckInfo && !initialized) {
            updateProgress(deckInfo.progresoActual); // Actualiza el progreso inicial
            updateLimProgress(selectedVillain.puntosNecesarios); // Actualiza el límite de progreso
            updateNumDays(diasActual); // Actualiza el número de días
            updateLimDays(selectedVillain.limiteDias); // Actualiza el límite de días
            updateBqValue(diasActual, numPlayers); // Actualiza el valor BQ

            setInitialized(true);

        }
    }, [deckInfo, updateNumDays, updateLimDays, updateBqValue, updateProgress, updateLimProgress]);

    const handleImageClick = () => {
        // Alterna entre la imagen frontal y la trasera
        setShowBackImage(!showBackImage);
    };

    const getUrlImageTirano = (imgNumber) => {
        return 'https://firebasestorage.googleapis.com/v0/b/tmbcards-3ec94.appspot.com/o/tiranos%2Ftirano_'+selectedVillain.clave+'_'+selectedVillain.keyname+'_'+imgNumber;
    }

    const getVillainImage = (imgNumber) => {
        // Usa la imagen trasera si showBackImage es verdadero
        return !showBackImage ? getUrlImageTirano(imgNumber)+'_frontal.jpg?alt=media': getUrlImageTirano(imgNumber)+'_trasera.jpg?alt=media';
    };

    // Verificar si la propiedad cartaExtra es igual a 1
    const showVillainControls = selectedVillain.cartaExtra > 0;

    const volverAventura = () => {
        const deckInfoRecibida = {
            numPlayers: numPlayers,
            selectedVillain: {
                name: selectedVillain.name,
                keyname: selectedVillain.keyname,
                encuentrosTirano: selectedVillain.encuentrosTirano,
                puntosNecesarios: selectedVillain.puntosNecesarios,
                limiteDias: selectedVillain.limiteDias,
                clave: selectedVillain.clave,
                cartaExtra: selectedVillain.cartaExtra,
            },
            diasActual: diasActual - 1,
            cartaDelMazo: cartaDelMazo,
            progresoActual: progresoActual,
            revisarEncuentros: revisarEncuentros,
            objetoNoSubirDia: objetoNoSubirDia,
            objetoEncuentro34Dia: objetoEncuentro34Dia,
            cardList: cardList
        };
        const deckInfoJSON = JSON.stringify(deckInfoRecibida, null, 2);
        console.log('volverAventura: ',deckInfoJSON);
        updateHeaderFieldDaysColor('red-background'); // Cambia el color a verde
        setTimeout(() => {
            updateHeaderFieldDaysColor(''); // Restablece el color después de 0.5 segundos
        }, 500);

        navigate('/Aventura', { state: { deckInfoJSON } });

    };

    const handlePreviousCard = () => {
        setImageNumber((prevNumber) => (prevNumber > 0 ? prevNumber - 1 : prevNumber)); //Decrementa hasta 0
    };
    
    const handleNextCard = () => {
        setImageNumber((prevNumber) => (prevNumber < selectedVillain.cartaExtra ? prevNumber + 1 : prevNumber)); //Incrementa hasta 1
    };

    const finalizarAventura = () => {
        //IR A EPILOGO (VICTORIA)
        showQuestion("¿Cómo ha terminado el combate?", "He ganado", "Me han derrotado", epilogoVictoria, epilogoDerrota);
        setShowQuestionBox(true);
    };

    const epilogoVictoria = () => {
        const deckInfoActualizada = {
            numPlayers: numPlayers,
            selectedVillain: {
                name: selectedVillain.name,
                keyname: selectedVillain.keyname,
                encuentrosTirano: selectedVillain.encuentrosTirano,
                puntosNecesarios: selectedVillain.puntosNecesarios,
                limiteDias: selectedVillain.limiteDias,
                clave: selectedVillain.clave,
                cartaExtra: selectedVillain.cartaExtra,
            },
            diasActual: diasActual,
            cartaDelMazo: cartaDelMazo,
            progresoActual: progresoActual,
            cardList: cardList
        };
        const deckInfoJSON = JSON.stringify(deckInfoActualizada, null, 2);

        navigate('/Epilogo', { state: { deckInfoJSON, resultado:'victoria' } });
    };

    const epilogoDerrota = () => {
        const deckInfoActualizada = {
            numPlayers: numPlayers,
            selectedVillain: {
                name: selectedVillain.name,
                keyname: selectedVillain.keyname,
                encuentrosTirano: selectedVillain.encuentrosTirano,
                puntosNecesarios: selectedVillain.puntosNecesarios,
                limiteDias: selectedVillain.limiteDias,
                clave: selectedVillain.clave,
                cartaExtra: selectedVillain.cartaExtra,
            },
            diasActual: diasActual,
            cartaDelMazo: cartaDelMazo,
            progresoActual: progresoActual,
            cardList: cardList
        };
        const deckInfoJSON = JSON.stringify(deckInfoActualizada, null, 2);

        navigate('/Epilogo', { state: { deckInfoJSON, resultado:'derrota' } });
    };

    //Volver a la aventura desde la opción de "ver carta tirano" (por lo que no se resta un día)
    const volverAventuraCartaTirano = () => {
            const deckInfoRecibida = {
                numPlayers: numPlayers,
                selectedVillain: {
                    name: selectedVillain.name,
                    keyname: selectedVillain.keyname,
                    encuentrosTirano: selectedVillain.encuentrosTirano,
                    puntosNecesarios: selectedVillain.puntosNecesarios,
                    limiteDias: selectedVillain.limiteDias,
                    clave: selectedVillain.clave,
                    cartaExtra: selectedVillain.cartaExtra,
                },
                diasActual: diasActual,
                cartaDelMazo: cartaDelMazo,
                progresoActual: progresoActual,
                revisarEncuentros: revisarEncuentros,
                objetoNoSubirDia: objetoNoSubirDia,
                objetoEncuentro34Dia: objetoEncuentro34Dia,
                cardList: cardList
            };
            const deckInfoJSON = JSON.stringify(deckInfoRecibida, null, 2);
    
            navigate('/Aventura', { state: { deckInfoJSON } });
      };

//Para mostrar json, añadir despues del primer <div>:             <pre>{deckInfoJSON}</pre> {/* Muestra el JSON en la pantalla */}
    return (
        <div className="">
            {verCartaTirano && (
                <div className="seccion-boton-atras">
                <button className='boton-volverAventura' onClick={volverAventuraCartaTirano}>
                    ← Volver a la aventura
                </button>
                </div>
            )}

            <div className="central-image">
            {selectedVillain && (
                    <>
                        <img
                            src={getVillainImage(imageNumber)}
                            alt={selectedVillain}
                            className="villain-image"
                            onClick={handleImageClick}
                        />
                        <p className="image-note">Haz click sobre la imagen para ver su parte trasera</p>
                    </>
                )}
            
            </div>

            {!verCartaTirano && (
                <>
                <div className='villain-wrap-controls-container'>
                    <button onClick={volverAventura} className="day-button"> Volver </button> 
                    {showVillainControls && (
                    <div className="villain-controls-container">
                        <div className="villain-controls">
                            <button onClick={handlePreviousCard} className="day-button" disabled={showQuestionBox}> &lt; </button> 
                            <button onClick={handleNextCard} className="day-button" disabled={showQuestionBox}> &gt; </button>
                        </div>
                    </div>
                    )}
                    <button onClick={finalizarAventura} className="day-button"> Finalizar aventura </button> 
                </div>
                </>
            )}
            {verCartaTirano && (
                <>
                <div className='villain-wrap-controls-container'>
                    {showVillainControls && (
                    <div className="villain-controls-container">
                        <div className="villain-controls">
                            <button onClick={handlePreviousCard} className="day-button" disabled={showQuestionBox}> &lt; </button> 
                            <button onClick={handleNextCard} className="day-button" disabled={showQuestionBox}> &gt; </button>
                        </div>
                    </div>
                    )}
                </div>
                </>
            )}

            {/* Cuadro centrado */}
            {showQuestionBox && (
                <div className="question-box">
                    <p>{questionText}</p>
                    <button onClick={button1Action}>{button1Text}</button>
                    <button onClick={button2Action}>{button2Text}</button>
                </div>
            )}

        </div>
    );
};

export default CombateTirano;
